import actionTypes from '../actions/actionTypes'

const defaultState = {
	transitioning: -1,
	redirectAfterRefer: false,
}

function showDoubleStorageAnimation(state) {
	const newState = {...state}
	newState.redirectAfterRefer = true
	return newState
}

const dmStorageExperimentReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.DM_STORAGE_EXPERIMENT_REFER_CONTACT_SEND:
		{
			return showDoubleStorageAnimation(state)
		}
		default:
			return state
	}
}

export default dmStorageExperimentReducer
